
import React from 'react';
import { Chart } from 'react-google-charts';


function SoilOrganicCarbon() {
    const data = [
        ["Task", "Hours per Day"],
        ["SOC_%", 11],
        ["Lorem", 2],
    ];
    
    
    const options = {
        title: "Soil Organic Carbon",
        is3D: true,
    };
    

    return (
        <div style={{ width: '100%' }}>
            <Chart
                chartType="PieChart"
                width="100%"
                height="400px"
                data={data}
                options={options}
            />        
        </div>
    );
}

export default SoilOrganicCarbon;